import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { ManageCampaignConfermanceGiasActions } from './manage-campaign-confermance-gias.actions';
import { ManageCampaignConfermanceGiasService } from '../../service/manage-campaign-confermance-gias.service';
import { GiasAssessmentActions } from '../gias-assessment/gias-assessment.actions';


@Injectable()
export class ManageCampaignConfermanceGiasEffects {

  loadLegalEntities$ = createEffect(
    (as: ManageCampaignConfermanceGiasService = inject(ManageCampaignConfermanceGiasService)) => {
      return this.actions$.pipe(
        ofType(ManageCampaignConfermanceGiasActions.loadLegalEntities),
        concatMap(({ campaignId, parameters }) =>
          as.getLegalEntitiesConfermanceGias(campaignId, parameters).pipe(
            map((manageCampaigns) =>
              ManageCampaignConfermanceGiasActions.loadLegalEntitiesSuccess({
                manageCampaigns
              })
            ),
            catchError((error) =>
              of(ManageCampaignConfermanceGiasActions.loadLegalEntitiesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  loadAllLegalEntities$ = createEffect(
    (as: ManageCampaignConfermanceGiasService = inject(ManageCampaignConfermanceGiasService)) => {
      return this.actions$.pipe(
        ofType(ManageCampaignConfermanceGiasActions.loadAllLegalEntities),
        concatMap(({ campaignId, parameters }) =>
          as.getLegalEntitiesConfermanceGias(campaignId, parameters).pipe(
            map((manageCampaigns) =>
              ManageCampaignConfermanceGiasActions.loadAllLegalEntitiesSuccess({
                manageCampaigns
              })
            ),
            catchError((error) =>
              of(ManageCampaignConfermanceGiasActions.loadAllLegalEntitiesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  loadAllLegalEntitiesFiltered$ = createEffect(
    (as: ManageCampaignConfermanceGiasService = inject(ManageCampaignConfermanceGiasService)) => {
      return this.actions$.pipe(
        ofType(ManageCampaignConfermanceGiasActions.loadAllLegalEntitiesFiltered),
        concatMap(({ campaignId, parameters }) =>
          as.getLegalEntitiesConfermanceGias(campaignId, parameters).pipe(
            map((manageCampaigns) =>
              ManageCampaignConfermanceGiasActions.loadAllLegalEntitiesFilteredSuccess({
                manageCampaigns
              })
            ),
            catchError((error) =>
              of(ManageCampaignConfermanceGiasActions.loadAllLegalEntitiesFilteredFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );


  constructor(private actions$: Actions) { }
}
